import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { Category } from '@/lib/types';

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: e } = await supabase
        .from('categories')
        .select('*')
        .order('name');
      if (e) throw e;
      setCategories((data as Category[]) ?? []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudieron cargar las categorías');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const createCategory = useCallback(async (name: string): Promise<Category | null> => {
    const trimmed = name.trim();
    if (!trimmed) return null;
    const { data, error: e } = await supabase
      .from('categories')
      .insert({ name: trimmed })
      .select('*')
      .single();
    if (e) throw e;
    setCategories((prev) => [...prev, data as Category].sort((a, b) => a.name.localeCompare(b.name)));
    return data as Category;
  }, []);

  return { categories, loading, error, load, createCategory };
}